import IconCirclePlus from 'assets/pricing/circle-plus.inline.svg';
import ButtonIconLeft from 'components/material-ui/ButtonIconLeft';
import { PRICING_PLAN } from 'components/pages/pricing/base/enumsPricing';
import { routes } from 'constants/routes';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useLanguage from 'hooks/useLanguage';
import useSearchParams from 'hooks/useSearchParams';
import parse from 'html-react-parser';
import { actionsPersist, usePersistDispatch } from 'providers/PersistProvider';
import React, { useEffect } from 'react';

export default function EnterpriseView({ plan }) {
	const dispatchPersist = usePersistDispatch();
	const { language, searchLangParams, subject } = useSearchParams();
	const { currency } = useLanguage();
	const { t } = useTranslation();

	// save basket and total price for summary
	useEffect(() => {
		dispatchPersist({
			type: actionsPersist.updatePersistData, payload: {
				pricingPlan: PRICING_PLAN.ENTERPRISE,
				currency: currency,
				totalCost: 0,
				basket: []
			}
		});
	}, []);

	return (
		<div style={{ maxWidth: '75rem' }} className="relative border-2 border-grey-E rounded-10 mx-15 xl:mx-auto mt-80 sm:mt-80">
			<div style={{ marginTop: '-0.25rem' }} className="absolute ml-22 top-0 w-70 h-03 xl:h-04 bg-violet-0 rounded-10"/>

			<div className="absolute top-0 right-0 -z-10">
				<StaticImage src="../../../../assets/pricing/images/bg-world.png" alt=""/>
			</div>

			<div className="pt-10 pb-15 px-22">
				<p className="text-15 font-bold mt-07 mb-05">{PRICING_PLAN[plan?.name]?.toUpperCaseChar()}</p>
				<div className="xl:pl-80 xl:pr-90 py-07 xl:py-15">
					<h2 className="mt-20">{t('pagePricing.plan.enterprise.h2')}<span className="text-green-1 font-normal text-shadow-none">_</span></h2>
					<div className="text-grey-7">{parse(plan?.description ?? '')}</div>

					<ButtonIconLeft name="choosePlanEnterprise" to={`${routes[language].CONTACT}?${subject}=${searchLangParams.subject.enterprise}`} Icon={IconCirclePlus} tw="w-150 mx-auto mt-24" size="medium">
						{t('pagePricing.label.choosePlanEnterprise')}
					</ButtonIconLeft>
				</div>
			</div>
		</div>
	);
}
